export const SOLOLETRAS = /^[a-zA-Z\s]*$/;
export const SOLONUMEROS = /^\d*$/
